import { Box, Typography } from "@mui/material";
import Magnifier from "../../../assets/magnifier.svg";

const headline = [
  ["A", "I", "で"],
  ["欲", "し", "い", "も", "の", "が"],
  ["す", "ぐ", "に", "見", "つ", "か", "る"],
];

export default function HeroSection() {
  return (
    <Box
      component="section"
      sx={(theme) => ({
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        overflow: "hidden",
      })}
    >
      <Box
        className="max-w-6xl mx-auto px-6"
        sx={{
          minHeight: 320,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          pt: { xs: 1, sm: 0 },
        }}
      >
        <div className="w-full flex flex-col items-center gap-6 sm:flex-row sm:justify-center sm:gap-10">
          {/* 左：テキストエリア */}
          <Box sx={{ zIndex: 1 }} className="w-full sm:w-auto">
            {/* 白□見出し */}
            <div className="flex flex-col gap-2 sm:gap-3 mb-4 sm:mb-6 items-start sm:items-start">
              {headline.map((line, rowIdx) => (
                <div key={rowIdx} className="flex gap-2">
                  {line.map((char, idx) => (
                    <span
                      key={idx}
                      className="
                        inline-flex
                        items-center
                        justify-center
                        w-[36px]
                        h-[36px]
                        sm:w-[44px]
                        sm:h-[44px]
                        bg-white
                        text-[#143282]
                        font-bold
                        text-[20px]
                        sm:text-[26px]
                        leading-none
                      "
                    >
                      {char}
                    </span>
                  ))}
                </div>
              ))}
            </div>

            {/* サブコピー */}
            <Typography
              variant="body1"
              sx={{
                opacity: 0.9,
                fontSize: { xs: 14, sm: 16 },
              }}
            >
              新しいショッピング体験をあなたに
            </Typography>
          </Box>

          {/* 右：虫眼鏡 */}
          <img
            src={Magnifier}
            alt=""
            className="
            absolute top-10 right-8
            w-[140px]
            pointer-events-none
            opacity-90

            sm:static
            sm:w-[200px]
            md:w-[300px]
          "
          />
        </div>
      </Box>
    </Box>
  );
}
